<template>
  <el-container  style="display: block;">

    <el-row   style="margin-top: 20px;margin-left: 3%;">
      <el-row :span="2" style="margin-top: 30px;">
        <el-row :span="2" style="margin-top: 30px;">
            <el-button type="primary" style="background-color: #409eff;" @click="add(1)" round>添加语句</el-button>
            <el-button type="primary" style="background-color: #EE5757;" @click="add(2)" round>添加指令</el-button>
        </el-row>





      </el-row>

        <el-row  class="elementsz" style="margin-top: 30px;">
          <template>
            <el-table
          	:data="list"
            height="1000"
          	border
          	style="width: 95%;margin-left: 0;height: 800px;text-align: center;">
            <el-table-column

              width="300"
              label="序号"
               >
               <template slot-scope="scope">
                   <div >{{scope.row.sorts}}</div>
               </template>
            </el-table-column>
            <el-table-column

              width="300"
              label="同序"
               >
               <template slot-scope="scope">
                   <div @click="dis(scope.row.id,1,scope.row.sortt)">{{scope.row.sortt}}</div>
               </template>
            </el-table-column>
            <el-table-column

              width="200"
              label="类型"
               >
               <template slot-scope="scope">
                   <div v-if="scope.row.type == 1" style="color: #409eff;">
                     <el-button type="primary" style="background-color: #409eff;" >语句</el-button>
                   </div>
                   <div v-if="scope.row.type == 2" style="color: #EE5757;">
                     <el-button type="primary" style="background-color: #EE5757;" >指令</el-button>
                   </div>
               </template>
            </el-table-column>
            <el-table-column

              width="400"
              label="内容"
               >
               <template slot-scope="scope">
                   <div @click="dis(scope.row.id,3,scope.row.name)">{{scope.row.name}}</div>
               </template>
            </el-table-column>
            <el-table-column

              width="200"
              label="时间"
               >
               <template slot-scope="scope">
                   <div @click="dis(scope.row.id,2,scope.row.times)">{{scope.row.times}}</div>
               </template>
            </el-table-column>
			<el-table-column
			
			  width="200"
			  label="限时"
			   >
			   <template slot-scope="scope">
			       <div @click="dis(scope.row.id,7,scope.row.xianshi)">{{scope.row.xianshi}}</div>
			   </template>
			</el-table-column>
            <el-table-column

              width="200"
              label="人物坐标"
               >
               <template slot-scope="scope">
                   <div @click="dis(scope.row.id,4,scope.row.zuobiao)">{{scope.row.zuobiao}}</div>
               </template>
            </el-table-column>
            <el-table-column

              width="200"
              label="讲解方向"
               >
               <template slot-scope="scope">
                   <div @click="disf(scope.row.id,6,scope.row.jfangxiang)">{{scope.row.jfangxiang}}</div>
               </template>
            </el-table-column>
            <el-table-column

              width="200"
              label="面向方向"
               >
               <template slot-scope="scope">
                   <div @click="disf(scope.row.id,5,scope.row.fangxiang)">{{scope.row.fangxiang}}</div>
               </template>
            </el-table-column>
            <el-table-column

              width="400"
              label="操作"
               >
               <template slot-scope="scope">
                 <el-button type="primary" style="background-color: #409eff;" @click.native="add2(1,scope.$index)">插入语句</el-button>
                 <el-button type="primary" style="background-color: #EE5757;" @click.native="add2(2,scope.$index)">插入指令</el-button>
                 <el-button type="primary" style="background-color: #555555;" @click.native="del(scope.$index)">删除</el-button>

               </template>
            </el-table-column>
            </el-table>
          </template>

        </el-row>






    </el-row>
    <el-dialog
      :title="chName"
      :visible.sync="changeVisible"
      width="30%"
      center>
      <input type="text" class="searchT" v-model="cname"/>
      <span slot="footer" class="dialog-footer">
    	<el-button @click="changeVisible = false">取 消</el-button>
    	<el-button type="primary" @click="dodisChange()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :title="addName"
      :visible.sync="disDialogVisible"
      width="30%"
      center>
      <div>
        内容：<el-input v-model="name" style="width: 350px;" placeholder="请输入内容"></el-input>
      </div>
      <div style="margin-top: 30px;">
        时间：<el-input v-model="time" style="width: 350px;" placeholder="请输入时间"></el-input>
      </div>


      <span slot="footer" class="dialog-footer">
    	<el-button @click="disDialogVisible = false">取 消</el-button>
    	<el-button type="primary" @click="doadd()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :title="addName"
      :visible.sync="disDialogVisible2"
      width="30%"
      center>
      <div>
        内容：<el-input v-model="name2" style="width: 350px;" placeholder="请输入内容"></el-input>
      </div>
      <div style="margin-top: 30px;">
        时间：<el-input v-model="time2" style="width: 350px;" placeholder="请输入时间"></el-input>
      </div>


      <span slot="footer" class="dialog-footer">
    	<el-button @click="disDialogVisible2 = false">取 消</el-button>
    	<el-button type="primary" @click="doadd2()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="修改讲解方向"
      :visible.sync="disjfangxiang"
      width="30%"
      center>
      <el-select v-model="jfangxiang"   filterable placeholder="请选择" >
          <el-option
            v-for="item in zyArr"
            :key="item"
            :label="item"
            :value="item">
          </el-option>
        </el-select>
      <span slot="footer" class="dialog-footer">
    	<el-button @click="disjfangxiang = false">取 消</el-button>
    	<el-button type="primary" @click="dochangezy(6)">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="修改面向方向"
      :visible.sync="disfangxiang"
      width="30%"
      center>
      <el-select v-model="fangxiang"   filterable placeholder="请选择" >
          <el-option
            v-for="item in zyArr"
            :key="item"
            :label="item"
            :value="item">
          </el-option>
        </el-select>
      <span slot="footer" class="dialog-footer">
    	<el-button @click="disfangxiang = false">取 消</el-button>
    	<el-button type="primary" @click="dochangezy(5)">确 定</el-button>
      </span>
    </el-dialog>
  </el-container>
</template>

<script>
  export default {
    data() {
       return {
         disjfangxiang:false,
         jfangxiang:'无',
         disfangxiang:false,
         fangxiang:'无',
         fId:0,
         zyArr:['无','左','右'],
         list:[],
         disDialogVisible:false,
         disDialogVisible2:false,
         changeVisible:false,
         changeId:0,
         j_id:this.$route.query.id,
         addName:'',
         addT:0,
         name:'',
         time:0,
         name2:'',
         time2:0,
         addIndex:0,
         cname:'',
         cid:0,
         t:0,
         chName:''


      }
    },
  directives: {
    },
    created() {

      this.loadList();

    },

  methods:{
    disf(id,t,name){
      this.fId = id

      if(t==5){
        this.fangxiang = name
        this.disfangxiang = true
      }
      if(t==6){
        this.jfangxiang = name
        this.disjfangxiang = true
      }


    },
    dochangezy(t){
      var name = ''
      if(t == 5){
        name = this.fangxiang
      }
      if(t == 6){
        name = this.jfangxiang
      }
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });

      axiosInstance({
      	method:'post',
      	data:{
      		id:this.fId,
          name:name,
          t:t
      	},
      	url:'http://y31p.yoooooo.com/index.php/index/data/yjiangjiemChange'
      })
      .then(res=>{
      	if(res.data.code == 200){

           this.$message({
           	type: 'success',
           	message: '操作成功'
           });
           this.fId = 0
           this.fangxiang = ''
           this.disfangxiang = false
           this.jfangxiang = ''
           this.disjfangxiang = false
           this.loadList();
      	}else{

      	}
       })
       .catch(err=>{

       });
    },
    dis(id,t,name){
      this.cid = id
      this.cname = name
      if(t==1){
        this.chName = '修改同序'
      }
      if(t==2){
        this.chName = '修改时间'
      }
      if(t==3){
        this.chName = '修改内容'
      }
      if(t==4){
        this.chName = '修改坐标'
      }
      if(t==5){
        this.chName = '修改方向'
      }
      this.t = t
      this.changeVisible = true
    },
    dodisChange(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });

      axiosInstance({
      	method:'post',
      	data:{
      		id:this.cid,
          name:this.cname,
          t:this.t
      	},
      	url:'http://y31p.yoooooo.com/index.php/index/data/yjiangjiemChange'
      })
      .then(res=>{
      	if(res.data.code == 200){

           this.$message({
           	type: 'success',
           	message: '操作成功'
           });
           this.cid = 0
           this.cname = ''
           this.changeVisible = false
           this.loadList();
      	}else{

      	}
       })
       .catch(err=>{

       });
    },
    add(t){
      this.addT = t
      if(t == 1){
        this.addName = '添加语句'
      }else{
        this.addName = '添加指令'
      }
      this.disDialogVisible = true
    },
    add2(t,index){
      this.addT = t

      this.addIndex = index + 1

      if(t == 1){
        this.addName = '插入语句'
      }else{
        this.addName = '插入指令'
      }
      this.disDialogVisible2 = true
    },
    doadd2(){


      this.list.splice(this.addIndex,0,{'id':0,'name':this.name2,'times':this.time2,'j_id':this.j_id,'sorts':0,'type':this.addT,'sortt':0,'zuobiao':'无','fangxiang':'无','jfangxiang':'无'})

      var num = this.addIndex
      var that = this
      this.list.forEach((item,index) => {
        if(index>num && item['sortt']>0){
          that.list[index]['sortt'] = that.list[index]['sortt']+1
        }
      });

      this.dochangeAll(JSON.stringify(this.list))

    },
    del(index){
      var num = index
      var that = this
      this.list.forEach((item,index) => {
        if(index>num && item['sortt']>0){
          that.list[index]['sortt'] = that.list[index]['sortt']-1
        }
      });

      this.list.splice(index,1)

      this.dochangeAll(JSON.stringify(this.list))
    },
    seach(){
      this.loadList();
    },
    ceshi(index,id){
      this.imageId = index
      this.imgId = id
    },

    loadList(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'get',
      	params:{
          j_id:this.j_id,


      	},
      	url:'http://y31p.yoooooo.com/index.php/index/data/yjiangjiemList'
      })
      .then(res=>{

        this.list = res.data.data;




      })
      .catch(err=>{

      });
    },
    dochangeAll(data){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });

      axiosInstance({
      	method:'post',
      	data:{
      		data:data,
          j_id:this.j_id
      	},
      	url:'http://y31p.yoooooo.com/index.php/index/data/yjiangjiemChangeAll'
      })
      .then(res=>{
      	if(res.data.code == 200){

           this.$message({
           	type: 'success',
           	message: '操作成功'
           });
           this.addT = 0
           this.name2 = 0
           this.time2 = 0
           this.addIndex = 0
           this.disDialogVisible2 = false
           this.loadList();
      	}else{

      	}

      })
      .catch(err=>{

      });
    },

    doadd(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      if(this.name == ''){
        this.msg('请填写名称','error')
        return false
      }



      axiosInstance({
      	method:'post',
      	url:'http://y31p.yoooooo.com/index.php/index/data/yjiangjiemAdd',
      	params:{
      		name:this.name,
          time:this.time,
          type:this.addT,
          j_id:this.j_id

      	}
      })
      .then(res=>{
        this.$message({
        	type: 'success',
        	message: '添加成功'
        });
        this.name = ''
        this.time = 0
        this.addT = 0
        this.disDialogVisible = false
        this.loadList()
      })
      .catch(err=>{

      });
    },
    msg(msg,type){
    	this.$message({
    	  message: msg,
    	  type: type
    	});
    },

  }


  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/main/yjiangjiem.vue